<!--
Copyright 2026 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<ng-container *ngIf="downloadUrl() as url; else loading">
  <img
    [src]="url"
    class="submission-img"
    alt="Submission photo"
    i18n-alt="@@app.labels.loadingSubmissionPhoto"
  />
</ng-container>
<ng-template #loading>
  <div *ngIf="unavailable(); else spinner" class="submission-img-unavailable">
    <mat-icon>image_not_supported</mat-icon>
    <span i18n="@@app.labels.submissionPhotoUnavailable">
      Photo unavailable. It may not have been uploaded yet, for example if the
      device was waiting for a Wi-Fi connection.
    </span>
  </div>
  <ng-template #spinner>
    <mat-spinner [diameter]="40"></mat-spinner>
  </ng-template>
</ng-template>
